import './signers.scss'

import { faPlusCircle, faTrash } from '@fortawesome/free-solid-svg-icons';
import { FormApi } from 'final-form';
import Vue from "vue";
import Component from "vue-class-component";
import { Watch } from 'vue-property-decorator';

import { TranslatedString } from '@skinsoft/i18n';
import { createTranslatedString, EnhancedTextArea, getTranslatedString } from '@skinsoft/ui';

export interface Signer {
    id: string,
    signer: TranslatedString
    signature: string
}

@Component({
    components: {
        sEnhancedTextArea: EnhancedTextArea
    },
    props: ['form', 'fieldName', 'signers'],
    template: require("./signers.html")
})
export class Signers extends Vue {

    public form: FormApi;

    public plusIcon = faPlusCircle;
    public minusIcon = faTrash;

    public signers: Signer[];
    public fieldName: string;

    // used to generate an id for v-for feature (v-bind:key)
    private lastId = 1;

    public addSigner() {
        this.lastId++;
        this.signers.push({
            id: this.lastId.toString(),
            signature: "",
            signer: createTranslatedString(this.$i18n.locale, ""),
        })
    }

    public removeSigner(index: number) {
        this.signers.splice(index, 1)
    }

    public signerFieldName(index) {
        return `${this.fieldName}.conditionReportCS.signers[${index}.signer.translatedString.${this.$i18n.locale}`
    }

    public getSignerName(signer: Signer) {
        return getTranslatedString(signer.signer, this.$i18n.locale)
    }

    @Watch('signers', { immediate: true, deep: true })
    public initSignersIfEmpty() {
        if (this.signers.length === 0) {
            this.addSigner()
        } else {
            this.signers.forEach(
                signer => {
                    if (!signer.id) {
                        this.lastId++;
                        signer.id = this.lastId.toString();
                    }
                }
            )
        }
    }

}